import React from 'react';
import { Chip } from '@heroui/react';
import {
  resolveExperimentTypes,
  getExperimentTypeLabel,
  getExperimentTypeColor
} from '@/utils/experiments';
import type { ExperimentItem } from '@/types';

interface ExperimentTypesBadgesProps {
  experiment: Pick<ExperimentItem, 'types' | 'type'>;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

export function ExperimentTypesBadges({
  experiment,
  size = 'sm',
  className = ''
}: ExperimentTypesBadgesProps) {
  const types = resolveExperimentTypes(experiment);

  if (types.length === 0) {
    return <span className="text-default-400 text-xs italic">—</span>;
  }

  return (
    <div className={`flex flex-wrap gap-1 ${className}`}>
      {types.map((t) => (
        <Chip
          key={t}
          color={getExperimentTypeColor(t)}
          size={size}
          variant="flat"
          className="font-medium"
        >
          {getExperimentTypeLabel(t)}
        </Chip>
      ))}
    </div>
  );
}
